<div    class="mv-28 mct-flex mct-row mct-justify-end mct-items-stretch mct-gap-16">
  <p>
    {{ 'revenue.posted-batches.search-returned' | translate | ucfirst }} <strong>{{ searchResult?.TotalCount }}</strong>
    {{ 'revenue.posted-batches.journal-entries.journal-entries' | translate }}
  </p>
  <div>
    <wl-busy [show]="exporting"></wl-busy>
    <button pButton type="button" [disabled]="exporting" class="atlas-btn atlas-btn-primary" (click)="exportResults()">
      {{ 'revenue.posted-batches.export-results' | translate | uppercase }}
    </button>
  </div>
</div>

<div class="atlas-table">
  <p-table [showGridlines]="true" [value]="searchResult?.Result" [paginator]="true" [rows]="searchParams ? searchParams.PageSize : 20" [lazy]="true" [totalRecords]="searchResult?.TotalCount" (onLazyLoad)="lazyLoad($event)">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="ApplyDate">
          {{ 'revenue.posted-batches.apply-date' | translate | ucfirst }}
          <p-sortIcon field="ApplyDate"></p-sortIcon>
        </th>
        <th pSortableColumn="AccountName">
          {{ 'revenue.posted-batches.journal-entries.account-name' | translate | ucfirst }}
          <p-sortIcon field="AccountName"></p-sortIcon>
        </th>
        <th pSortableColumn="BatchPosting">
          {{ 'revenue.posted-batches.batch-number' | translate | ucfirst }}
          <p-sortIcon field="BatchPosting"></p-sortIcon>
        </th>
        <th pSortableColumn="Account">
          {{ 'revenue.posted-batches.account-number' | translate | ucfirst }}
          <p-sortIcon field="Account"></p-sortIcon>
        </th>
        <th pSortableColumn="DebitAmount">
          {{ 'revenue.posted-batches.journal-entries.debit-amount' | translate | ucfirst }}
          <p-sortIcon field="DebitAmount"></p-sortIcon>
        </th>
        <th pSortableColumn="CreditAmount">
          {{ 'revenue.posted-batches.journal-entries.credit-amount' | translate | ucfirst }}
          <p-sortIcon field="CreditAmount"></p-sortIcon>
        </th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-journalEntries>
      <tr>
        <td>{{ journalEntries.ApplyDate | date : 'MM/dd/yyyy' }}</td>
        <td>{{ journalEntries.AccountName }}</td>
        <td>{{ journalEntries.BatchPosting }}</td>
        <td>{{ journalEntries.Account }}</td>
        <td>{{ journalEntries.DebitAmount | currency }}</td>
        <td>{{ journalEntries.CreditAmount | currency }}</td>
      </tr>
    </ng-template>
  </p-table>
<p-progressSpinner *ngIf="loading"></p-progressSpinner>
  <wl-page-size-dropdown [(pageSize)]="searchParams.PageSize" [pageSizes]="[20, 100, 0]"
    (pageSizeChange)="pageSizeChanged()"></wl-page-size-dropdown>
</div>